import {Component, inject, OnInit} from '@angular/core';
import {NZ_MODAL_DATA, NzModalRef} from "ng-zorro-antd/modal";
import {FormGroup} from "@angular/forms";
import {autoFitColumns, SharedService, StickerStatus} from "../../shared/shared.service";
import {ProxyDynamicService} from "../../shared/service/proxy-dynamic.service";
import {TranslateService} from "@ngx-translate/core";
import * as XLSX from "xlsx";
import moment from "moment";
import {NzNotificationService} from "ng-zorro-antd/notification";

@Component({
  selector: 'app-modal-import',
  templateUrl: './modal-import.component.html',
  styleUrl: './modal-import.component.scss'
})
export class ModalImportComponent implements OnInit {
  readonly nzModalData = inject(NZ_MODAL_DATA);
  formGroup!: FormGroup;
  mode: 'list' | 'cancel' = 'list';
  url = ''
  file?: any;
  type: any;
  listStickerType: any = []

  ngOnInit() {
  }

  constructor(
    private modalRef: NzModalRef,
    private service: ProxyDynamicService,
    private translate: TranslateService,
    private noti: NzNotificationService,
    private sharedService: SharedService
  ) {
    this.listStickerType = this.nzModalData.listStickerType;
    this.mode = this.nzModalData.mode;
  }

  destroyModal() {
    this.modalRef.destroy();
  }

  onSave() {
    this.sharedService.showLoading(true);
    if (this.mode === 'list') {
      this.service.importSticker(this.file).subscribe((res: any) => {
        this.noti.success(this.translate.instant('sticker.import-success'), '');
        this.modalRef.destroy(true);
        this.sharedService.showLoading(false);
      }, (error: any) => {
        this.handleError(error.error);
      })
    } else {
      this.service.importStickerCancel(this.file).subscribe((res: any) => {
        this.noti.success(this.translate.instant('sticker.import-success'), '');
        this.modalRef.destroy(true);
        this.sharedService.showLoading(false);
      }, (error: any) => {
        this.handleError(error.error);
      })
    }
  }

  handleError(error: any) {
    this.sharedService.showLoading(false);
    if (error.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      try {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const data = e.target.result;
          const wb = XLSX.read(data, { type: 'array' });
          XLSX.writeFile(wb, this.translate.instant('sticker.template-' + this.mode) + '_lỗi.xlsx');
        };
        // Read the file as ArrayBuffer
        reader.readAsArrayBuffer(error);
      } catch (catchError: any) {
        console.error(catchError.message);
      }
    } else if (error.type === 'application/json') {
      try {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const data = JSON.parse(e.target.result);
          this.noti.error(data.details || data.message, '')
        };
        // Read the file as ArrayBuffer
        reader.readAsText(error);
      } catch (catchError: any) {
        console.error(catchError.message);
      }
    }
  }

  downloadTemplate() {
    this.sharedService.showLoading(true);
    let filter = {};
    if (this.mode === 'cancel' && !!this.type) {
      filter = {type: {'_in': this.type}, status: {'_eq': StickerStatus.Imported}}
      this.service.search('sticker_tran', {
        fields: ['*.*'], filter: filter,
        "limit": 20000,
      }).then((res: any) => {
        let listJSON: any[] = [];
        listJSON = res.map((item: any) => {
          const obj: any = {};
          obj[this.translate.instant('sticker.' + this.mode + '_date')] = moment(item.date).format('DD/MM/YYYY');
          obj[this.translate.instant('sticker-type.code')] = item.type.code;
          obj[this.translate.instant('sticker.seri')] = item.seri;
          return obj;
        });
        for (let i = 0; i <= (4000 - listJSON.length); i++) {
          const temp: any = {};
          temp[this.translate.instant('sticker.' + this.mode + '_date')] = '';
          temp[this.translate.instant('sticker-type.code')] = '';
          temp[this.translate.instant('sticker.seri')] = '';
          listJSON.push(temp);
        }

        const listJSON2 = this.listStickerType.map((item: any, index: number) => {
          const obj: any = {};
          obj[this.translate.instant('index')] = index + 1;
          obj['id'] = item.id;
          obj[this.translate.instant('sticker-type.code')] = item.code;
          obj[this.translate.instant('sticker-type.name')] = item.name;
          return obj
        });

        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        const ws1 = XLSX.utils.json_to_sheet(listJSON);
        autoFitColumns(ws1, listJSON);
        for (let rowIndex = 2; rowIndex <= 4000; rowIndex++) {
          const cellAddress = `A${rowIndex}`;
          if (ws1[cellAddress]) {
            ws1[cellAddress].z = "dd/mm/yyyy"; // Apply date format
          }
        }
        XLSX.utils.book_append_sheet(wb, ws1, 'Danh sách');
        autoFitColumns(XLSX.utils.json_to_sheet(listJSON2), listJSON2);
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(listJSON2), 'Loại Sticker');
        XLSX.writeFile(wb, this.translate.instant('sticker.template-' + this.mode) + '.xlsx');
        this.sharedService.showLoading(false);
      })
    } else {
      let listJSON: any[] = [];
      const obj: any = {};
      obj[this.translate.instant('sticker.' + this.mode + '_date')] = moment().format('DD/MM/YYYY');
      obj[this.translate.instant('sticker-type.code')] = '';
      obj[this.translate.instant('sticker.seri')] = '';
      listJSON = [obj];
      for (let i = 0; i <= (4000 - listJSON.length); i++) {
        const temp: any = {};
        temp[this.translate.instant('sticker.' + this.mode + '_date')] = '';
        temp[this.translate.instant('sticker-type.code')] = '';
        temp[this.translate.instant('sticker.seri')] = '';
        listJSON.push(temp);
      }

      const listJSON2 = this.listStickerType.map((item: any, index: number) => {
        const obj: any = {};
        obj[this.translate.instant('index')] = index + 1;
        obj['id'] = item.id;
        obj[this.translate.instant('sticker-type.code')] = item.code;
        obj[this.translate.instant('sticker-type.name')] = item.name;
        return obj
      });

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      const ws1 = XLSX.utils.json_to_sheet(listJSON);
      autoFitColumns(ws1, listJSON);
      for (let rowIndex = 2; rowIndex <= 4000; rowIndex++) {
        const cellAddress = `A${rowIndex}`;
        if (ws1[cellAddress]) {
          ws1[cellAddress].z = "dd/mm/yyyy"; // Apply date format
        }
      }

      XLSX.utils.book_append_sheet(wb, ws1, 'Danh sách');
      autoFitColumns(XLSX.utils.json_to_sheet(listJSON2), listJSON2);
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(listJSON2), 'Loại Sticker');
      XLSX.writeFile(wb, this.translate.instant('sticker.template-' + this.mode) + '.xlsx');
      this.sharedService.showLoading(false);
    }
  }

  handleFileUpload(event: any) {
    this.file = event;
  }
}
